/**
 * This browser's draft is the working copy. The server snapshot (starter, last
 * check, or workspace) is only the fallback when this device has nothing saved.
 * Reloading after a failed Check My Work must not replace unsubmitted edits.
 */
export function resolveEditorInitialSource(input: {
  authoringPy?: string;
  localDraft: string | null;
  serverPy: string;
}): string {
  const authoring = input.authoringPy?.trim() ?? "";
  if (authoring) return authoring;
  if (input.localDraft && input.localDraft.trim().length > 0) return input.localDraft;
  return input.serverPy;
}
